export default "__VITE_ASSET__CtzAzKZy__"